// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
export const safeGetAJS$ = () => window.AJS && window.AJS.$;

export const safeGetAJS$DomNode = (domNode?: HTMLElement | null) => {
	const AJS$ = safeGetAJS$();
	return AJS$ && AJS$(domNode);
};
